import { render, staticRenderFns } from "./MenuDetail.vue?vue&type=template&id=5e40d646&"
import script from "./MenuDetail.vue?vue&type=script&lang=js&"
export * from "./MenuDetail.vue?vue&type=script&lang=js&"
import style0 from "./MenuDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports